module.exports = __webpack_public_path__ + "static/media/AudienceLocation-es.267914e4.jpg";